import { render, staticRenderFns } from "./elementheader.vue?vue&type=template&id=27adc537&"
import script from "./elementheader.vue?vue&type=script&lang=ts&"
export * from "./elementheader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27adc537')) {
      api.createRecord('27adc537', component.options)
    } else {
      api.reload('27adc537', component.options)
    }
    module.hot.accept("./elementheader.vue?vue&type=template&id=27adc537&", function () {
      api.rerender('27adc537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/elementheader.vue"
export default component.exports